/* ChatHistory.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0rIjyk2ADO%7Bmargin-block-end%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065U2ADO%7Bpadding-block%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5E2ADO%7Bpadding-inline-start%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPFQfX%7Bpadding-inline-end%3Avar(--ds-space-025%2C2px)%7D");
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import IconButton from '@atlaskit/button/icon/button';
import AddIcon from '@atlaskit/icon/core/add';
import SearchIcon from '@atlaskit/icon/core/search';
import HistoryIcon from '@atlaskit/icon-lab/core/history';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { usePublish, useSubscribe } from '@atlaskit/rovo-triggers/main';
import { ExpandableMenuItem, ExpandableMenuItemTrigger, ExpandableMenuItemContent } from '@atlaskit/side-nav-items/expandable-menu-item';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuSection, MenuSectionHeading } from '@atlaskit/side-nav-items/menu-section';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';
import { SideNavProvider } from '@atlassian/conversation-assistant';
import ConversationAssistant from '@atlassian/conversation-assistant/AsyncConversationAssistant';
import { useRovoNavigation } from '@atlassian/conversation-assistant/controllers/rovo-navigation';
import { useSmartCreationChatStoreApi } from '@atlassian/conversation-assistant/controllers/smart-creation-api';
import { Conversation } from '@atlassian/conversation-assistant-store/controllers/chat/types';
import { useUIStore, useUIStoreActions } from '@atlassian/conversation-assistant-store/controllers/ui-store';
import { DeleteConversationModal } from '@atlassian/conversation-assistant-ui-components/ui/chat-conversation-list/DeleteConversationModal';
import { ChatListMenuItems } from '@atlassian/rovo-navigation/chat-list-items';
import { SpaceMenuItems } from '@atlassian/rovo-navigation/space-items';
import { useSpaceStoreActions } from '@atlassian/rovo-spaces/controllers/space-store';
import { CreateSpaceModal } from '@atlassian/rovo-spaces/ui/CreateSpaceModal';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAnalytics } from '@townsquare/analytics';
import { useTownsquareApp } from '@townsquare/app-context';
import { isInRovoFullscreenPages } from '@townsquare/chat-view/__router-route';
import { DividerCompiled } from '@townsquare/divider';
import { getEmojiProviderForCloudId } from '@townsquare/emoji-provider';
import { useRouterActions } from '@townsquare/router/primitives/actions';
import { Link } from '@townsquare/router/primitives/link';
import { useRouter } from '@townsquare/router/useRouter';
import { chatRoute, createChatRouteQuery } from '@townsquare/routes/chat';
import { sharedConversationPreviewRoute } from '@townsquare/routes/shared-conversation-preview';
import { useAssistanceServiceParams, useRovoParams, useRovoProductHeader } from '@townsquare/rovo/hooks';
import { useHandleOpenPanel } from '@townsquare/rovo-chat/hooks';
import { expVal } from '@townsquare/stat-sig';
import { ROVO_CHAT_SPACES_EXPERIMENT, TOWNSQUARE_ROVO_CHAT_SEARCH_BUTTON_EXP } from '@townsquare/stat-sig/experiments';
import { fg } from '@townsquare/stat-sig/gate';
import { useUserStore } from '@townsquare/user-store';
import { ChatHistorySkeleton } from './ChatHistorySkeleton';
const MAX_CONVERSATIONS = 20;
const styles = {
  container: "_0rIjyk2ADO",
  heading: "_4c065U2ADO _0LQT5E2ADO _1UtDYzZpcK",
  addButtonAlignment: "_03SyCPFQfX"
};
type ConversationAssistantInitProps = {
  cloudId: string;
  userId: string | undefined;
};
const EMPTY_CONVO_ID = 'EMPTY_CONVERSATION_ID';
/**
 * Initialises Conversation Assistant to ensure chat store and other state is initialised.
 */
const ConversationAssistantInit = ({
  cloudId,
  userId
}: ConversationAssistantInitProps) => {
  const app = useTownsquareApp();
  const product = useRovoProductHeader();
  const config = useMemo(() => ({
    product,
    siteId: cloudId,
    userId,
    xpcProduct: 'townsquare',
    xpcSubProduct: `townsquare-${app}`,
    assistanceServiceConfig: {
      headers: {
        'X-Cloudid': cloudId
      },
      baseUrl: '/gateway/api/assist'
    }
  }), [cloudId, userId, app, product]);
  return <VisuallyHidden>
			{/* overridingChildren is required so that only state is initialised. This prevents duplicate listeners from being added. */}
			<ConversationAssistant config={config} overridingChildren={<></>} uiConfig={{
      preserveUrlConversationId: true
    }} />
		</VisuallyHidden>;
};
const ChatList = ({
  onCreateSpaceClick,
  closeRovoSidebar,
  isSpacesEnabled
}: {
  onCreateSpaceClick: () => void;
  closeRovoSidebar: () => void;
  isSpacesEnabled: boolean;
}) => {
  const {
    cloudId
  } = useRovoParams();
  const publish = usePublish('ai-mate');
  const [{
    accountId: userId
  }] = useUserStore();
  const {
    addSpace
  } = useSpaceStoreActions();
  const assistanceServiceParams = useAssistanceServiceParams({
    experienceId: 'ai-mate',
    touchpointSource: 'townsquare-sidenav'
  });
  const {
    conversations,
    currentConversation,
    handleConversationClick,
    handleViewAllConversationsClick,
    handleViewAllSpacesClick,
    handleConversationPinToggle,
    editConversation: {
      handleEditConversationConfirm
    },
    deleteConversation: {
      openDeleteModal,
      conversationToBeDeleted,
      handleDeleteConfirm
    },
    moveToSpace: {
      handleMoveConversationToSpace,
      handleMoveConversationToNewSpace,
      conversationToMoveToNewSpace,
      clearConversationToMoveToNewSpace
    },
    isConversationsInitialized
  } = useRovoNavigation({
    assistanceServiceParams,
    isTasksEnabled: fg('rovo_chat_enable_tasks'),
    conversationLimit: MAX_CONVERSATIONS
  });
  const {
    pushTo
  } = useRouterActions();
  const [routerState] = useRouter();
  const routeSpaceId = routerState.query.rovoChatConversationId ? undefined : routerState.query.rovoChatSpaceId;
  // The shared preview renders someone else's conversation, so the viewer's own current
  // conversation must not be highlighted in the sidebar lists while it is open.
  const shouldHighlightCurrentConversation = isInRovoFullscreenPages(routerState.route.name) && routerState.route.name !== sharedConversationPreviewRoute.name;
  const {
    activeMenu,
    setActiveMenu
  } = useUIStore();
  const {
    setSelectedConversation
  } = useSmartCreationChatStoreApi();
  const onSelectConversation = useCallback((conversation: Conversation, isADSNavigationEnabled: boolean) => {
    closeRovoSidebar();
    pushTo(chatRoute, {
      query: createChatRouteQuery(routerState.query, {
        rovoChatPathway: 'chat',
        rovoChatConversationId: conversation.id
      })
    });
    handleConversationClick(conversation, isADSNavigationEnabled);
  }, [closeRovoSidebar, pushTo, routerState.query, handleConversationClick]);
  const onViewAllConversations = useCallback(() => {
    closeRovoSidebar();
    publish({
      type: 'space-deselected',
      source: 'rovo-sidebar-navigation',
      openChat: false
    });
    pushTo(chatRoute, {
      query: createChatRouteQuery(routerState.query, {
        rovoChatPathway: 'all-conversations'
      })
    });
    handleViewAllConversationsClick();
    setSelectedConversation({
      conversationId: ''
    });
  }, [closeRovoSidebar, pushTo, publish, handleViewAllConversationsClick, setSelectedConversation, routerState.query]);
  const onViewAllSpacesClick = useCallback(() => {
    closeRovoSidebar();
    publish({
      type: 'space-deselected',
      source: 'rovo-sidebar-navigation',
      openChat: false
    });
    pushTo(chatRoute, {
      query: createChatRouteQuery(routerState.query, {
        rovoChatPathway: 'all-spaces'
      })
    });
    handleViewAllSpacesClick();
    setSelectedConversation({
      conversationId: ''
    });
  }, [closeRovoSidebar, pushTo, publish, handleViewAllSpacesClick, setSelectedConversation, routerState.query]);

  // Track which space is currently selected so we can highlight the correct nav item.
  const [selectedSpaceId, setSelectedSpaceId] = useState<string | undefined>(routeSpaceId);
  const isRecommendedSpacesSelected = shouldHighlightCurrentConversation && !routerState.query.rovoChatConversationId && !routeSpaceId && activeMenu === 'recommended-spaces';
  useEffect(() => {
    setSelectedSpaceId(routeSpaceId);
  }, [routeSpaceId]);
  useSubscribe({
    topic: 'ai-mate'
  }, event => {
    if (event.type === 'space-selected') {
      setSelectedSpaceId(event.data.spaceId);
    } else if (event.type === 'space-deselected' || event.type === 'chat-new') {
      setSelectedSpaceId(undefined);
      setConversationLocation('loose');
    }
  });

  // When the user picks any conversation (either inside a space or in the
  // loose list), we want to drop the space-level highlight so only the
  // conversation row is shown as selected. There's no dedicated event for
  // conversation selection, so we clear the local state directly from the
  // click handlers below.
  const clearSpaceHighlight = useCallback(() => {
    setSelectedSpaceId(undefined);
    setActiveMenu('none');
  }, [setActiveMenu]);

  // Track WHERE the currently-selected conversation lives so we pass
  // `currentConversation` to exactly one list. Without this, a conversation
  // appearing in both the per-space API result AND the loose chat-store list
  // (same id, both with `rovoSpaceId: null`) would highlight in two places.
  //
  // 'loose' → show in ChatListMenuItems only
  // 'space' → show in SpaceMenuItems only
  // null (initial page-load) → default to 'loose'
  const [conversationLocation, setConversationLocation] = useState<'loose' | 'space' | null>(null);
  const effectiveLocation = conversationLocation ?? 'loose';
  const conversationForLooseList = shouldHighlightCurrentConversation && !selectedSpaceId && !isRecommendedSpacesSelected && effectiveLocation === 'loose' ? currentConversation : undefined;
  const conversationForSpaceList = shouldHighlightCurrentConversation && !selectedSpaceId && !isRecommendedSpacesSelected && effectiveLocation === 'space' ? currentConversation : undefined;
  const hasNoConversations = conversations.length < 1 || conversations.length === 1 && conversations[0].id === EMPTY_CONVO_ID;
  const isPinnedChatsEnabled = fg('rovo_chat_pinned_fe');
  const chatListContent = !isConversationsInitialized ? <ChatHistorySkeleton /> : hasNoConversations ? <Inline space="space.100" alignBlock="center" spread="space-between" xcss={styles.heading} role="listitem">
			<Text size="medium" weight="medium" color="color.text.subtle">
				<FormattedMessage id="townsquare.rovo-side-nav.chat-history.empty-state-title" defaultMessage="Nothing here yet. <a>Start a chat with Rovo</a>." description="Title for the chat history section in the side navigation when there are no chats" values={{
        a: chunks =>
        // Townsquare Link routes both pointer clicks and Enter presses through onClick.
        // The keyboard props describe that custom interactive contract to static a11y lint.
        <Link to={chatRoute} query={createChatRouteQuery(routerState.query)} onClick={closeRovoSidebar} onKeyDown={closeRovoSidebar} role="link" tabIndex={0}>
								{chunks}
							</Link>
      }} />
			</Text>
		</Inline> : <ChatListMenuItems conversations={conversations}
  // When a space or the recommended-spaces panel is selected, clear the
  // "current conversation" highlight in the standalone list so only the
  // space / recommended-spaces nav item appears selected. Mirrors the
  // behaviour of the platform `SideNavigation` component.
  currentConversation={conversationForLooseList} onSelectConversation={(conversation, isADSNavigationEnabled) => {
    clearSpaceHighlight();
    setConversationLocation('loose');
    onSelectConversation(conversation, isADSNavigationEnabled);
  }} onConversationDelete={openDeleteModal} onConversationRename={handleEditConversationConfirm} onConversationPinToggle={isPinnedChatsEnabled ? handleConversationPinToggle : undefined} onViewAllConversations={onViewAllConversations} onConversationMoveToSpace={handleMoveConversationToSpace} onConversationMoveToNewSpace={handleMoveConversationToNewSpace} isADSNavigationEnabled={true} isNewAllConversationScreenEnabled={fg('rovo_chat_chat_history_refresh')} cloudId={cloudId} />;
  return <>
			{isSpacesEnabled && isConversationsInitialized && <MenuSection isMenuListItem>
					<Inline alignBlock="center" spread="space-between">
						<MenuSectionHeading>
							<FormattedMessage id="townsquare.rovo-side-nav.chat-history.spaces-subsection-title" defaultMessage="Spaces" description="Title for the Spaces subsection in the Rovo side navigation chat history section" />
						</MenuSectionHeading>
						<Inline alignBlock="center" space="space.050" xcss={styles.addButtonAlignment}>
							<CreateSpaceButton onClick={onCreateSpaceClick} />
						</Inline>
					</Inline>
					<MenuList>
						<SpaceMenuItems conversations={conversations}
        // When a space (or the recommended-spaces panel) is selected at the
        // space level, no individual conversation should appear as the
        // "current" one. Once the user picks a conversation inside a space,
        // `selectedSpaceId` is cleared and the conversation row becomes the
        // only highlighted item.
        currentConversation={conversationForSpaceList} onSelectConversation={(conversation, isADSNavigationEnabled) => {
          clearSpaceHighlight();
          setConversationLocation('space');
          onSelectConversation(conversation, isADSNavigationEnabled);
        }} onConversationDelete={openDeleteModal} onConversationRename={handleEditConversationConfirm} onConversationPinToggle={isPinnedChatsEnabled ? handleConversationPinToggle : undefined} onSelectSpace={space => {
          closeRovoSidebar();
          pushTo(chatRoute, {
            query: createChatRouteQuery(routerState.query, {
              rovoChatPathway: 'chat',
              rovoChatSpaceId: space.id
            })
          });
          publish({
            type: 'space-selected',
            source: 'rovo-sidebar-navigation',
            openChat: false,
            data: {
              spaceId: space.id,
              title: space.name,
              emoji: space.emoji ?? '',
              description: space.description ?? undefined,
              entryPoint: 'leftNav'
            }
          });
        }} onSelectRecommendedSpaces={() => {
          closeRovoSidebar();
          setSelectedSpaceId(undefined);
          setActiveMenu('recommended-spaces');
          pushTo(chatRoute, {
            query: createChatRouteQuery(routerState.query, {
              rovoChatPathway: 'recommended-spaces'
            })
          });
        }} onRecommendedSpacesFirstTimeClick={() => {
          publish({
            type: 'recommended-spaces-first-time-selected',
            source: 'rovo-sidebar-navigation',
            openChat: false
          });
        }} selectedSpaceId={selectedSpaceId} isRecommendedSpacesSelected={isRecommendedSpacesSelected} isADSNavigationEnabled={true} isNewAllConversationScreenEnabled={fg('rovo_chat_chat_history_refresh')} onViewAllSpacesClick={onViewAllSpacesClick} cloudId={cloudId} userId={userId ?? undefined} product={assistanceServiceParams.product} experienceId="ai-mate" />
					</MenuList>
				</MenuSection>}
			{isSpacesEnabled ? <MenuSection isMenuListItem>
					<Inline alignBlock="center" spread="space-between">
						<MenuSectionHeading>
							<FormattedMessage id="townsquare.rovo-side-nav.chat-history.chats-subsection-title" defaultMessage="Chats" description="Title for the Chats subsection in the Rovo side navigation chat history section" />
						</MenuSectionHeading>
						<Inline xcss={styles.addButtonAlignment}>
							<NewChatButton closeRovoSidebar={closeRovoSidebar} />
						</Inline>
					</Inline>
					<MenuList>{chatListContent}</MenuList>
				</MenuSection> : chatListContent}
			{conversationToBeDeleted && <DeleteConversationModal onDeleteConfirm={() => handleDeleteConfirm(conversationToBeDeleted.id)} />}
			{conversationToMoveToNewSpace && <CreateSpaceModal isOpen={true} onClose={clearConversationToMoveToNewSpace} cloudId={cloudId} initialConversationId={conversationToMoveToNewSpace.id} onCreated={(response, emojiId) => {
      addSpace(response, emojiId);
      clearConversationToMoveToNewSpace();
    }} />}
		</>;
};
const NewChatButton = ({
  closeRovoSidebar
}: {
  closeRovoSidebar: () => void;
}) => {
  const intl = useIntl();
  const publish = usePublish('ai-mate');
  const assistanceServiceParams = useAssistanceServiceParams({
    experienceId: 'ai-mate',
    touchpointSource: 'townsquare-sidenav'
  });
  const {
    handleNewChatClick
  } = useRovoNavigation({
    assistanceServiceParams
  });
  const {
    pushTo
  } = useRouterActions();
  const [routerState] = useRouter();
  const onNewChatClick = useCallback(() => {
    closeRovoSidebar();
    pushTo(chatRoute, {
      query: createChatRouteQuery(routerState.query, {
        rovoChatPathway: 'chat'
      })
    });
    handleNewChatClick(true);
  }, [closeRovoSidebar, handleNewChatClick, pushTo, routerState.query]);
  return <IconButton icon={AddIcon} label={intl.formatMessage({
    id: 'townsquare.rovo-side-nav.chat-history.new-chat-button-label',
    defaultMessage: 'New chat',
    description: 'Label for the new chat button in the chat history section in the side navigation'
  })} onClick={() => {
    publish({
      type: 'space-deselected',
      source: 'rovo-sidebar-navigation',
      openChat: false
    });
    onNewChatClick();
  }} appearance="subtle" spacing="compact" isTooltipDisabled={false} />;
};

// Use narrow actions here to avoid mounting another useRovoNavigation instance.
const SearchChatsButton = ({
  closeRovoSidebar
}: {
  closeRovoSidebar: () => void;
}) => {
  const {
    formatMessage
  } = useIntl();
  const analytics = useAnalytics();
  const publish = usePublish('ai-mate');
  const {
    setActiveMenu,
    setShouldFocusChatSearch
  } = useUIStoreActions();
  const {
    pushTo
  } = useRouterActions();
  const [routerState] = useRouter();
  const isChatRoute = routerState.route.name === chatRoute.name;
  const onSearchChats = useCallback(() => {
    void analytics.ui('rovoChatSearchChatsButton', 'clicked', {
      source: 'townsquare-home-side-nav'
    });
    closeRovoSidebar();
    publish({
      type: 'space-deselected',
      source: 'rovo-sidebar-navigation',
      openChat: false
    });
    setShouldFocusChatSearch(true);
    if (isChatRoute) {
      setActiveMenu('conversation-list');
    }
    pushTo(chatRoute, {
      query: createChatRouteQuery(routerState.query, {
        rovoChatPathway: 'all-conversations'
      })
    });
  }, [analytics, closeRovoSidebar, publish, setShouldFocusChatSearch, isChatRoute, setActiveMenu, pushTo, routerState.query]);
  return <IconButton testId="rovo-chat-sidenav-chat-search" icon={SearchIcon} label={formatMessage({
    id: 'townsquare.rovo-side-nav.chat-history.search-chats-button-label',
    defaultMessage: 'Search conversations',
    description: 'Label for the button that opens conversation search from the chat history section in the side navigation'
  })} onClick={onSearchChats} appearance="subtle" spacing="compact" isTooltipDisabled={false} />;
};
const CreateSpaceButton = ({
  onClick
}: {
  onClick: () => void;
}) => {
  const intl = useIntl();
  return <IconButton testId="rovo-chat-sidenav-spaces-create-space" icon={AddIcon} label={intl.formatMessage({
    id: 'townsquare.rovo-side-nav.chat-history.create-space-button-label',
    defaultMessage: 'Create space',
    description: 'Label for the create space button in the chat history section in the side navigation'
  })} onClick={onClick} appearance="subtle" spacing="compact" isTooltipDisabled={false} />;
};
const ChatHistoryActions = ({
  closeRovoSidebar,
  isSpacesEnabled,
  isSearchChatsEnabled
}: {
  closeRovoSidebar: () => void;
  isSpacesEnabled: boolean;
  isSearchChatsEnabled: boolean;
}) => {
  return <Inline alignBlock="center" space="space.050" testId="rovo-chat-sidenav-your-chats-actions">
			{isSearchChatsEnabled && <SearchChatsButton closeRovoSidebar={closeRovoSidebar} />}
			{!isSpacesEnabled && <NewChatButton closeRovoSidebar={closeRovoSidebar} />}
		</Inline>;
};
const ChatHistoryExpandable = ({
  isDefaultExpanded,
  onCreateSpaceClick,
  closeRovoSidebar,
  isSpacesEnabled
}: {
  isDefaultExpanded?: boolean;
  onCreateSpaceClick: () => void;
  closeRovoSidebar: () => void;
  isSpacesEnabled: boolean;
}) => {
  const analytics = useAnalytics();
  const [routerState] = useRouter();
  const isSearchChatsEnabled = expVal(TOWNSQUARE_ROVO_CHAT_SEARCH_BUTTON_EXP, 'isEnabled', false);
  const onExpansionToggle = useCallback((isExpanded: boolean) => {
    void analytics.ui('rovoAppChatHistorySection', 'toggled', {
      toggleAction: isExpanded ? 'expanded' : 'collapsed',
      screen: routerState.route.name
    });
  }, [analytics, routerState.route.name]);
  return <ExpandableMenuItem isDefaultExpanded={isDefaultExpanded} onExpansionToggle={onExpansionToggle}>
			<ExpandableMenuItemTrigger elemBefore={<HistoryIcon label="" color="currentColor" />} actions={(isSearchChatsEnabled || !isSpacesEnabled) && <ChatHistoryActions closeRovoSidebar={closeRovoSidebar} isSpacesEnabled={isSpacesEnabled} isSearchChatsEnabled={isSearchChatsEnabled} />}>
				<FormattedMessage id="townsquare.rovo-side-nav.chat-history.title" defaultMessage="Your chats" description="Title for the chat history section in the side navigation" />
			</ExpandableMenuItemTrigger>
			{/* ExpandableMenuItemContent has a role of List, so the children need to be role='listitem' */}
			<ExpandableMenuItemContent>
				<ChatList onCreateSpaceClick={onCreateSpaceClick} closeRovoSidebar={closeRovoSidebar} isSpacesEnabled={isSpacesEnabled} />
			</ExpandableMenuItemContent>
		</ExpandableMenuItem>;
};
const ChatHistoryInner = ({
  isDefaultExpanded,
  cloudId,
  userId
}: {
  isDefaultExpanded: boolean;
  cloudId: string;
  userId: string | undefined;
}) => {
  const [isCreateSpaceModalOpen, setIsCreateSpaceModalOpen] = useState(false);
  const {
    addSpace
  } = useSpaceStoreActions();
  const publish = usePublish('ai-mate');
  const {
    pushTo
  } = useRouterActions();
  const [routerState] = useRouter();
  const {
    handleClosePanel,
    isRovoSidebarOpen
  } = useHandleOpenPanel();
  const isSpacesEnabled = expVal(ROVO_CHAT_SPACES_EXPERIMENT, 'isEnabled', false);
  const closeRovoSidebar = useCallback(() => {
    if (isRovoSidebarOpen) {
      handleClosePanel();
    }
  }, [handleClosePanel, isRovoSidebarOpen]);
  const emojiProvider = useMemo(() => cloudId && userId ? getEmojiProviderForCloudId(cloudId, userId) : undefined, [cloudId, userId]);
  const onCreateSpaceClick = useCallback(() => {
    setIsCreateSpaceModalOpen(true);
  }, []);
  return <>
			<Stack space="space.100" xcss={styles.container}>
				<DividerCompiled margin="0px -12px" height="1px" />
				<MenuList>
					<ChatHistoryExpandable isDefaultExpanded={isDefaultExpanded} key={isDefaultExpanded ? 'expanded' : 'collapsed'} // This is to force re-render when the route changes
        onCreateSpaceClick={onCreateSpaceClick} closeRovoSidebar={closeRovoSidebar} isSpacesEnabled={isSpacesEnabled} />
				</MenuList>
				<DividerCompiled margin="0px -12px" height="1px" />
			</Stack>
			{isSpacesEnabled && isCreateSpaceModalOpen && <CreateSpaceModal isOpen={true} onClose={() => setIsCreateSpaceModalOpen(false)} cloudId={cloudId} emojiProvider={emojiProvider} onCreated={(response, emojiId) => {
      addSpace(response, emojiId);
      setIsCreateSpaceModalOpen(false);
      closeRovoSidebar();
      pushTo(chatRoute, {
        query: createChatRouteQuery(routerState.query, {
          rovoChatPathway: 'chat',
          rovoChatSpaceId: response.id
        })
      });
      publish({
        type: 'space-selected',
        source: 'rovo-sidebar-navigation',
        openChat: false,
        data: {
          spaceId: response.id,
          title: response.name,
          emoji: emojiId ?? '',
          description: response.description ?? undefined,
          entryPoint: 'leftNav'
        }
      });
    }} />}
		</>;
};
export const ChatHistory = ({
  isDefaultExpanded = false
}: {
  isDefaultExpanded?: boolean;
}): React.ReactNode => {
  const {
    cloudId
  } = useRovoParams();
  const [currentUser] = useUserStore();
  return <SideNavProvider>
			{/* Initialise Conversation Assistant to ensure chat store and other state is initialised */}
			<ConversationAssistantInit cloudId={cloudId} userId={currentUser.accountId ?? undefined} />
			<ChatHistoryInner isDefaultExpanded={isDefaultExpanded} cloudId={cloudId} userId={currentUser.accountId ?? undefined} />
		</SideNavProvider>;
};